<div class="card">
    <!-- <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="font-bold">{{'MI_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
        </div>
    </ng-template> -->
     
    <div class="field md:col-12 col-12">
        <div *ngIf="pondBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center mb-2" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'blue', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Pond/Tank Under Process Action Wise Details' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="pondBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onPONDChartClick($event)"></p-chart>
        </div>
    </div>
    

    <!-- <div class="card" *ngIf="actionType==3" > -->
    <div class="card" *ngIf="false" >

        <div class="p-fluid p-formgrid" style="display: flex; flex-wrap: wrap; justify-content: center;">
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'APP_VERIFICATION' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('AppVerification')">{{ underProcessCount?.IncompleteApps | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'PRE_SURVEY' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('PreEstimation')">{{ underProcessCount?.preestimate | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'VENDOR_ESTIMATES' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('Estimation')">{{ underProcessCount?.pendingEstimateApp | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'ESTIMATE_VERIFICATION' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('EstVerification')">{{ underProcessCount?.pendingEstApproved | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'CHALLAN_GENERATION' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('Challan')">{{ underProcessCount?.pending_challan | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'CHALLAN_DEPOSITED' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('ChallanDeposited')">{{ underProcessCount?.pending_challan_deposit | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'BOQ' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('BOQ')">{{ underProcessCount?.Pending_BOQ | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'PHYSICAL_VER' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('PVVerification')">{{ underProcessCount?.pending_PV | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'SUBSIDY_CALCULATION' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('Subsidy')">{{ underProcessCount?.pending_Subsidy | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'LOT_GENERATION' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('subsidy_lot')">{{ underProcessCount?.pending_lot | number:'1.0-2'}}</div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="max-width: 230px;">
                <div class="box">
                    <div class="total">{{ 'SUBSIDY_DISBURSEMENT' | translate}}</div>
                    <div class="count" (click)="onClickCountBox('subsidyDis')">{{ underProcessCount?.pending_subsidy_disbursal | number:'1.0-2'}}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- <p-card styleClass="p-card-shadow mt-2"> -->
        
    <div *ngIf="showDrillDownTable" class="dashboardTable" #dataTable>
        <p-table  #miSurvey [value]="pondTableDataWithFilter" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'appid',
            'District',
            'Block',
            'Village',
            'nextuser',
            'NextAction',
            'assigneddate',
            'Level_ID',
            'ActionType',
            'Status',
            'nextuser',
            'NextAction',
            'KYCStatus',
            'TransDate',
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}">
            <ng-template pTemplate="caption">
                <div class="grid d-flex align-items-center justify-content-end" [ngStyle]="{'color': 'white', 'background-color': tableHeaderColor}">
                    <!-- Left side -->
                    <div class="col-12 md:col-3">
                        <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'white'}">{{ tableHeaderName | translate}}</h5>
                    </div>
                    <!-- Middle section for buttons -->
                    <div class="col-12 md:col-4 d-flex justify-content-center">
                        <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                        <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                            placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                    </div>
                    <!-- Right side for search -->
                    <div class="col-12 md:col-5 gap-3 d-flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                        </span>
                        <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                        <p-menu #menu [popup]="true" [model]="pondUnderProcessReport"></p-menu>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th>{{'S_NO'| translate}}
                        <!-- <p-columnFilter type="text" field="Row_No" display="menu"></p-columnFilter>
                    <p-sortIcon field="Row_No"></p-sortIcon> -->
                    </th>
                    <th pSortableColumn="appid">{{'APP_ID'| translate}}</th>
                    <th pSortableColumn="District">{{'DISTRICT'| translate}}</th>
                    <th pSortableColumn="Block">{{'BLOCK'| translate}}</th>
                    <th pSortableColumn="Village">{{'VILLAGE'| translate}}</th>
                    <th pSortableColumn="Level_ID">{{'CURRENT_LEVEL'| translate}}</th>
                    <th pSortableColumn="ActionType">{{'CURRENT_ACTION'| translate}}</th>
                    <th pSortableColumn="assigneddate">{{'LAST_ACTION_DATE'| translate}}</th>
                    <th pSortableColumn="Status">{{'STATUS'| translate}}</th>
                    <th pSortableColumn="nextuser">{{'PENDING_LEVEL'| translate}}</th>
                    <th pSortableColumn="NextAction">{{'PENDING_ACTION'| translate}}</th>
                    <th pSortableColumn="KYCStatus">{{'KYC Status'| translate}}</th>
                    <th>{{'KYC Date'| translate}}</th>
                    <th>{{'VIEW' | translate}}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
                <tr class="body-section">
                    <td>{{ ri + 1 }}</td>
                    <td>{{consolidateData?.appid}}</td>
                    <td>{{consolidateData?.District}}</td>
                    <td>{{consolidateData?.Block}}</td>
                    <td>{{consolidateData?.Village}}</td>
                    <td>{{consolidateData?.Level_ID}}</td>
                    <td>{{consolidateData?.ActionType}}</td>
                    <td>{{consolidateData?.assigneddate | date: "mediumDate"}}</td>
                    <td>{{consolidateData?.Status}}</td>
                    <td>{{consolidateData?.nextuser}}</td>
                    <td>{{consolidateData?.NextAction}}</td>
                    <td>{{consolidateData?.KYCStatus}}</td>
                    <td>{{consolidateData?.TransDate}}</td>
                    <td>
                        <button pButton pRipple pTooltip="view application" icon="pi pi-eye"
                            class="p-button-rounded p-button-accent p-button-primary p-button-sm"
                            (click)="printForm(consolidateData.appid)"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="footer">
                
            </ng-template>

        </p-table>
    </div>
    <!-- <div class="mt-2" style="display: flex; justify-content: center;">
        <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary" (click)="onClickBack()"></button>
    </div> -->
</div>
